/**
 * Elovia Labs — keep cart drawer in sync after AJAX add-to-cart.
 * Shrine sometimes opens the drawer before section HTML is applied (esp. mobile / fresh sessions).
 */
(function () {
  if (window.__eloviaCartDrawerSync) return;
  window.__eloviaCartDrawerSync = true;

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function patchEmptyState(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    drawer.querySelectorAll('.drawer__inner-empty').forEach(function (el) {
      el.remove();
    });
  }

  function applySections(state) {
    var drawer = drawerEl();
    if (!drawer || !state || !state.sections) return false;
    if (typeof drawer.renderContents !== 'function') return false;
    try {
      drawer.renderContents(state);
      patchEmptyState(drawer);
      return true;
    } catch (e) {
      return false;
    }
  }

  function refreshDrawerSections() {
    var drawer = drawerEl();
    if (!drawer) return Promise.resolve();
    var url =
      '/cart?sections=cart-drawer,cart-icon-bubble&sections_url=' +
      encodeURIComponent(window.location.pathname);
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        applySections({ sections: sections });
      })
      .catch(function () {});
  }

  function cartCountFromHeading(drawer) {
    var text = drawer && drawer.querySelector('.drawer__heading');
    if (!text) return null;
    var m = text.textContent.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function verifyDrawer() {
    var drawer = drawerEl();
    if (!drawer || !drawer.classList.contains('active')) return;
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.item_count) return;
        var shown = cartCountFromHeading(drawer);
        var stale =
          shown === 0 ||
          drawer.querySelector('.drawer__inner-empty') ||
          drawer.classList.contains('is-empty');
        if (stale) refreshDrawerSections();
      })
      .catch(function () {});
  }

  // Clears the spurious "There was an error while updating your cart" message that the
  // theme writes after a SUCCESSFUL quantity change (a cart-update subscriber throws
  // post-render and trips updateQuantity's internal catch, even though the cart updated).
  function clearSpuriousCartErrors() {
    var selectors = ['#CartDrawer-CartErrors', '#cart-errors', '.cart-item__error-text'];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el && el.textContent && el.textContent.trim()) {
          el.textContent = '';
        }
      });
    });
  }

  function clearErrorsRepeatedly() {
    // Re-run a few times to beat the theme writing the message after re-render.
    [60, 200, 400, 700].forEach(function (delay) {
      setTimeout(clearSpuriousCartErrors, delay);
    });
  }

  function isSuccessfulCartChange(data) {
    // Success = a cart object (has item_count) with no error/status fields.
    if (!data || typeof data !== 'object') return false;
    if (data.status || data.errors || data.message) return false;
    return typeof data.item_count !== 'undefined';
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    return origFetch.apply(this, arguments).then(function (response) {
      if (!url) return response;

      // Suppress false errors after a successful quantity change/update.
      if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        if (response.ok) {
          response
            .clone()
            .json()
            .then(function (data) {
              if (isSuccessfulCartChange(data)) clearErrorsRepeatedly();
            })
            .catch(function () {});
        }
        return response;
      }

      if (url.indexOf('/cart/add') === -1) return response;
      var clone = response.clone();
      clone
        .json()
        .then(function (data) {
          if (data && data.status) return;
          if (data && data.sections) {
            setTimeout(function () {
              if (!applySections(data)) refreshDrawerSections();
            }, 0);
            setTimeout(verifyDrawer, 400);
          } else {
            setTimeout(refreshDrawerSections, 100);
          }
        })
        .catch(function () {});
      return response;
    });
  };

  function watchDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) {
        setTimeout(verifyDrawer, 50);
        setTimeout(verifyDrawer, 500);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
